// extracted by mini-css-extract-plugin
module.exports = {"root":"searchForm_root__1_0JW","inputWrap":"searchForm_inputWrap__G_P_R","btnSubmit":"searchForm_btnSubmit__2duV0"};